import React, { useCallback, useState } from 'react';
import { Table } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { getFlatsTableColumns } from './utils/getFlatsTableColumns';
import useTablePagination from '../../../../hooks/useTablePagination';
import FlatsExpandedRow from './components/FlatsExpandedRow';
import {
  setFlatsTablePage,
  setSelectedFlats,
} from '../../../../store/actions/housingStockActions';
import { columnKeyMap } from '../constants/columnKeyMap';
import { flatsTableComponents } from './constants/flatsTableComponents';

const { Column } = Table;

const selectTablePage = (state) => state.housingStockStore.flatsTablePage;
const selectFlatsData = (state) => state.housingStockStore.selectedFlatsData;

const FlatsTable = ({
  dataSource,
  sortedInfo,
  filteredInfo,
  hasPagination = true,
  hideAcceptanceStatusesCol = true,
  onChange,
  AddAndInfoActions,
  queryKeys,
  typesFilter,
  stagesFilter,
  stepsFilter,
  acceptanceStatusesFilter,
  salesFilter,
  ...props
}) => {

  const dispatch = useDispatch();

  const currentPage = useSelector(selectTablePage);
  const selectedFlatsData = useSelector(selectFlatsData);

  const setCurrentPage = useCallback(
    (page) => dispatch(setFlatsTablePage(page)),
    [dispatch]
  );

  const onCheckAllChange = (checked) => {
    const data = checked ? dataSource : [];
    dispatch(setSelectedFlats(data));
  };

  const tableSelectionChange = (flat, checked) => {
    let updateData;

    if (checked) {
      updateData = selectedFlatsData.some((f) => f.addressId === flat.addressId)
        ? selectedFlatsData
        : [...selectedFlatsData, flat];
    } else {
      updateData = selectedFlatsData.filter(
        (f) => f.addressId !== flat.addressId
      );
    }

    dispatch(setSelectedFlats(updateData));
  };

  const { shownItems, pagination } = useTablePagination(dataSource, {
    currentPage,
    setCurrentPage,
  });

  const [expandedRowKeys, setExpandedRowKeys] = useState([]);

  const removeRowFromSelection = (rowId) => {
    const updateRowKeys = expandedRowKeys.filter((key) => key !== rowId);
    setExpandedRowKeys(updateRowKeys);
  };

  const addRowToSelection = (rowId) => {
    const updateRowKeys = [...expandedRowKeys, rowId];
    setExpandedRowKeys(updateRowKeys);
  };

  const handleRowClick = (rowId) => {
    if (expandedRowKeys.includes(rowId)) {
      removeRowFromSelection(rowId);
    } else {
      addRowToSelection(rowId);
    }
  };

  const columns = getFlatsTableColumns({
    expandedRowKeys,
    sortedInfo,
    filteredInfo,
    types: typesFilter,
    stages: stagesFilter,
    acceptanceStatuses: acceptanceStatusesFilter,
    AddAndInfoActions,
    selectedFlatsData,
    dataSource,
    onCheckAllChange,
    tableSelectionChange,
    steps: stepsFilter,
    sales: salesFilter,
    setCurrentPage,
  });

  const hideColConditions = {
    [columnKeyMap.flatAcceptanceResult]: hideAcceptanceStatusesCol,
  };

  return (
    <>
      <Table
        {...props}
        rowKey="addressId"
        dataSource={hasPagination ? shownItems : dataSource}
        pagination={false}
        components={flatsTableComponents}
        expandIconAsCell={false}
        expandedRowKeys={expandedRowKeys}
        expandedRowRender={(record, _index, _indent) => (
          <FlatsExpandedRow record={record} queryKeys={queryKeys} />
        )}
        onRow={(record) => {
          return {
            'data-flat-id': record.addressId,
            id: `flat-row-${record.addressId}`,
            onClick: () => handleRowClick(record.addressId),
            expanded: expandedRowKeys.includes(record.addressId),
          };
        }}
        onChange={onChange}
      >
        {/* {Boolean(entranceName) && (
          <Column
            width="8%"
            key="entranceName"
            render={() => (
              <CellContent topRowContent={entranceName} isHighlighted />
            )}
          />
        )} */}

        {columns.map((column) => {
          if (Boolean(hideColConditions[column.key])) {
            return null;
          }
          return <Column {...column} />;
        })}
      </Table>
      {hasPagination && pagination}
    </>
  );
};

export default FlatsTable;
